import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import AutopilotSettings from "./AutopilotSettings";
import NewAutomation from "./NewAutomation";
import SubscribedView from "./SubscribedView";
import UnsubscribedView from "./UnsubscribedView";

export default function Autopilot() {
  const { isAutopilotPlan } = useContext(SubscriptionContext);

  if (!isAutopilotPlan) {
    return <UnsubscribedView />;
  }

  return (
    <Routes>
      <Route path="/" element={<SubscribedView />} />
      <Route path="new/source" element={<NewAutomation />} />
      <Route path="new/:draftId/*" element={<NewAutomation />} />
      <Route path="settings" element={<AutopilotSettings />} />
    </Routes>
  );
}
